import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";

const OddsByPromotionWidgetAsyncComponent = AsyncComponent(async () => import('./odds-by-promotion-widget' /* webpackChunkName: "Odds-by-promotion-widget" */ ));

export const OddsByPromotionWidgetAsync = (props) => {
  return <OddsByPromotionWidgetAsyncComponent {...props}/>
};
